import { Module, VuexModule, Action, Mutation, getModule } from 'vuex-module-decorators'
import store from '@/store'
import { Pedido, PedidoDetalle } from '@/types/types'
import { PedidoService } from '@/services/PedidoService'
@Module({
  namespaced: true,
  name: 'pedidos',
  store,
  dynamic: true
})
class PedidoModule extends VuexModule {
  items: Pedido[] = []
  itemsDetail: PedidoDetalle[] = []
  service = new PedidoService()

  @Action({ commit: 'setItems' })
  // eslint-disable-next-line
  async fetchAll (filter: any) {
    const pedidos = await this.service.fectchAllRequest(filter.start, filter.end)
    return pedidos.data
  }

  @Mutation
  setItems (items: Pedido[]) {
    this.items = items
  }

  @Action({ commit: 'setItemsDetail' })
  async fetchDetails (id: string) {
    const pedidos = await this.service.fectchDetailRequest(id)
    return pedidos.data
  }

  @Mutation
  setItemsDetail (items: PedidoDetalle[]) {
    this.itemsDetail = items
  }
}

export default getModule(PedidoModule)
